import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import { loginUser } from '../../modules/user'

import Login from '../../components/login/Login'

class LoginContainer extends React.Component {
  render() {
    const { loginUser, authError } = this.props
    return <Login error={authError} onSubmit={loginUser} />
  }
}

const mapStateToProps = ({ user }) => ({
  isAuthenticating: user.isAuthenticating,
  authError: user.authError,
})

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      loginUser,
    },
    dispatch
  )

export default connect(mapStateToProps, mapDispatchToProps)(LoginContainer)
